var CLOSEST_DIV_URL, ClosestDivision;

CLOSEST_DIV_URL = '/layout/get_location_sort?callback=?';

module.exports = ClosestDivision = {
  getClosestDivision: function(options) {
    var error, lang, lat, lng, loc, locale, ref, success;
    if (options == null) {
      options = {};
    }
    loc = options.loc, lat = options.lat, lng = options.lng, success = options.success, error = options.error;
    lang = document.head.getAttribute('data-language');
    locale = document.head.getAttribute('data-locale');
    if ((ref = this._xhr) != null) {
      ref.abort();
    }
    this._xhr = $.getJSON(CLOSEST_DIV_URL, {
      loc: loc,
      lat: lat,
      lng: lng,
      lang: lang,
      locale: locale
    }, success);
    return this._xhr.fail(error);
  },
  abort: function() {
    var ref;
    return (ref = this._xhr) != null ? ref.abort() : void 0;
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvY29tbW9uL21fY2xvc2VzdF9kaXZpc2lvbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9jb21tb24vbV9jbG9zZXN0X2RpdmlzaW9uLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLGVBQUEsR0FBa0I7O0FBR2xCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGVBQUEsR0FDZjtFQUFBLGtCQUFBLEVBQW9CLFNBQUMsT0FBRDtBQUNsQixRQUFBOztNQURtQixVQUFVOztJQUM1QixpQkFBRCxFQUFNLGlCQUFOLEVBQVcsaUJBQVgsRUFBZ0IseUJBQWhCLEVBQXlCO0lBRXpCLElBQUEsR0FBUyxRQUFRLENBQUMsSUFBSSxDQUFDLFlBQWQsQ0FBMkIsZUFBM0I7SUFDVCxNQUFBLEdBQVMsUUFBUSxDQUFDLElBQUksQ0FBQyxZQUFkLENBQTJCLGFBQTNCOztTQUVKLENBQUUsS0FBUCxDQUFBOztJQUNBLElBQUMsQ0FBQSxJQUFELEdBQVEsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxlQUFWLEVBQTJCO01BQUMsS0FBQSxHQUFEO01BQU0sS0FBQSxHQUFOO01BQVcsS0FBQSxHQUFYO01BQWdCLE1BQUEsSUFBaEI7TUFBc0IsUUFBQSxNQUF0QjtLQUEzQixFQUEwRCxPQUExRDtXQUNSLElBQUMsQ0FBQSxJQUFJLENBQUMsSUFBTixDQUFXLEtBQVg7RUFSa0IsQ0FBcEI7RUFVQSxLQUFBLEVBQU8sU0FBQTtBQUNMLFFBQUE7MENBQUssQ0FBRSxLQUFQLENBQUE7RUFESyxDQVZQIn0=
